import React from 'react';
import PropTypes from 'prop-types';
import { Accordion } from '@cimpress/react-components';

import '../../css/formatSelection.css';

import Slider from '../Slider';
import ToggleButtons from '../ToggleButtons';

const sizeSelection = ({ onSelectFormat, onSelectQuality, format, quality, colorMap }) => (
    <div className='format-control'>
        <Accordion title='Image format options' defaultOpen={true}>
            <ToggleButtons
                className='format-control__format'
                style={{ borderColor: colorMap.format }}
                options={['png', 'jpg']}
                value={format}
                onSelect={onSelectFormat}
            />
            <div className='color-attribute format-control__quality' style={{ borderColor: colorMap.quality }}>
                <Slider min={1} disabled={format !== 'jpg'} value={quality} onSelect={onSelectQuality} label='Image quality' />
            </div>
        </Accordion>
    </div>
);

sizeSelection.propTypes = {
    onSelectFormat: PropTypes.func.isRequired,
    onSelectQuality: PropTypes.func.isRequired,
    format: PropTypes.string.isRequired,
    quality: PropTypes.number.isRequired,
    colorMap: PropTypes.shape({
        format: PropTypes.string.isRequired,
        quality: PropTypes.string.isRequired,
    }).isRequired,
};

export default sizeSelection;



// WEBPACK FOOTER //
// ./src/components/rendering/formatSelection.jsx